module.exports = __webpack_public_path__ + "img/ok.fde2b820.png";